import { Load } from "components/load";
import PageError from "components/page-error";
import { Button } from "components/ui/button";
import { Input } from "components/ui/input";
import { debounce } from "lodash";
import { useCallback, useEffect } from "react";
import { Meta } from "src/@types/paginated";
import { useDialogModal } from "../../../../hook/handle-modal/hooks/actions";
import { useGetAccountingAccountsQuery } from "../../../../services/account-accouting";
import { handeOrderBy } from "../../../../utils/pagination";
import Table from "../components/table";
import { Create } from "../create";
import { useAccountingAccountFilterActions } from "../ducks/filter/hooks/actions";
import { useFilterState } from "../ducks/filter/hooks/filterState";
import { columns } from "./columns";
import { ContentContainer, PageLayout, PageTitle } from "components/layout";

export const AccountingAccount: React.FC = () => {
  const { updateFilter } = useAccountingAccountFilterActions();
  const filterState = useFilterState();
  const { filters } = filterState || { filters: {} };
  const { handleModal } = useDialogModal();
  const orderBy = handeOrderBy(filters.order);

  const { data, isLoading, isFetching, error } = useGetAccountingAccountsQuery({
    search: filters.search,
    orderBy: JSON.stringify(orderBy),
    meta: {
      page: filters?.meta?.page || 1,
    },
  });

  const { meta, data: accountingAccount } = data || { meta: {}, data: [] };

  const handleInputChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    updateFilter({ key: "search", value: event.target.value });
  };

  const debouncedHandleInputChange = useCallback(
    debounce(handleInputChange, 500),
    [],
  );
  //Pata considerar o isFetching
  // const load = isFetching || isLoading;
  // Para considerar apenas o isLoading
  const load = isLoading;
  const openModalCreate = () => {
    handleModal({
      isOpen: true,
      element: <Create />,
      title: "Adicionar conta contábil",
    });
  };

  useEffect(() => {
    updateFilter({ key: "search", value: "" });
  }, []);

  if (error) {
    return <PageError status={500} message={"ERRO INTERNO NO SERVIDOR"} />;
  }

  if (load) {
    return <Load />;
  }
  return (
    <PageLayout>
      <PageTitle
        title="Gerenciar Contas Contábeis"
        description="Visualize os dados de contas contábeis."
      />
      <ContentContainer className="flex flex-col gap-3">
        <div className="flex w-full">
          <div className="w-full">
            <Input
              type="text"
              onChange={debouncedHandleInputChange}
              placeholder="Pesquisar conta contábil"
              className="h-8 bg-white"
            />
          </div>
          <div className="w-full flex justify-end">
            <Button
              variant="default"
              onClick={openModalCreate}
              className="h-8 border rounded-md"
            >
              Adicionar Conta Contábil
            </Button>
          </div>
        </div>
        <Table
          columns={columns}
          meta={meta as Meta}
          data={accountingAccount}
          isFetching={isFetching}
        />
      </ContentContainer>
    </PageLayout>
  );
};
